
import React, { useEffect } from 'react'
import { Button, Table, Form, Input, Space, Popconfirm, Modal, Select, message } from 'antd'
//导入图标
import { PlusOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
//查询
import { searchFun } from '@/utils'

//导入样式
import '@/scss/common.scss'

// //新增
import Add from './add'
//查看
import Seedata from './seedata'
//mobx
import { useStore } from '@/store'
import { observer } from 'mobx-react-lite'
import { runInAction, set, toJS } from 'mobx'


const App = () => {

    //mobx
    const { DeviceStore } = useStore()
    const [form] = Form.useForm()

    const navigate = useNavigate()

    //查询
    const onFinish = async (values) => {
        let data = searchFun(values)

        runInAction(() => {
            set(DeviceStore, { filter: data.content })
            set(DeviceStore, { op: data.rule })
            set(DeviceStore, { page: 1 })

        })
        await DeviceStore.getDataList()
    }
    //重置
    const onReset = () => {
        form.resetFields()
    }

    //获得table数据
    useEffect(() => {
        runInAction(() => {
            set(DeviceStore, { filter: '' })
            set(DeviceStore, { op: '' })
            set(DeviceStore, { page: 1 })
            set(DeviceStore, { limit: 10 })
            set(DeviceStore, { Num: 0 })
        })
        DeviceStore.getDataList()
      // DeviceStore.newselect()
        // eslint-disable-next-line
    }, [])

    //弹出新增角色框
    const getAddRole = (title) => {
        runInAction(() => {
            set(DeviceStore, { isAshow: true })
            set(DeviceStore, { title: title })
        })
    }
    //弹出框按钮关闭
    const handleAddRole = () => {
        runInAction(() => {
            set(DeviceStore, { isAshow: false })
        })
    }

    const seedata = (item, title) => {
        let items = toJS(item)
        runInAction(() => {
            set(DeviceStore, { seevalue: items })
            set(DeviceStore, { title: title })
            set(DeviceStore, { isAshow: true })
        })
    }
    //分页控制
    const onPageChange = (page, pageSize) => {
        runInAction(() => {
            set(DeviceStore, { page: page })
            set(DeviceStore, { limit: pageSize })
        })
        DeviceStore.getDataList()
    }
    //删除
    const confirm = async (item) => {
        let id = toJS(item).DevId
        await DeviceStore.getDeleteButtom(id)
    }
    //下拉框
    const { Option } = Select;

    //传感器
    const setting = async (item) => {
        let DevCode = toJS(item).DevCode
        runInAction(() => {
            set(DeviceStore, { DevCode: DevCode })
        })
      // await DeviceStore.setPage(DevCode)
      navigate(`/devicemanage?DevCode=${DevCode}`)
    }

    const columns = [
        // {
        //     title: '设备ID',
        //     dataIndex: 'DevId',
        // },
        {
            title: '设备名称',
            dataIndex: 'DevName',
        },
        {
            title: '设备编号',
            dataIndex: 'DevCode',
        },
        // {
        //     title: '链接时间',
        //     dataIndex: 'ConnTime',
        // },
        {
            title: '操作',
            render: (item) => (
                <Space size="middle">
                    <a onClick={() => seedata(item, '查看数据')}>查看</a>
                    <Popconfirm
                        title="是否删除"
                        onConfirm={() => { confirm(item) }}
                        okText="确定"
                        cancelText="取消"
                    >
                        <a href="#">删除</a>
                    </Popconfirm>
                    <a onClick={() => setting(item)}>设置</a>
                </Space>
            ),
        },
    ]
    return (
        <>
            <div className='topTitle'>
                <div className='titleBtn'>设备管理</div>
            </div>
            <div className='searchBox'>
                <Button type="primary" icon={<PlusOutlined />} className='addTitle' onClick={() => getAddRole('添加设备')}>添加设备</Button>
                <div className='TableInput'>
                    <Form layout="inline" onFinish={onFinish} form={form}>
                        <Form.Item label='关键词'>
                            <Input.Group compact>
                                <Form.Item name='select'>
                                    <Select placeholder="请选择" style={{ width: '100px' }}>
                                        <Option value="DevId">设备ID</Option>
                                        <Option value="DevName">设备名称</Option>
                                        <Option value="DevCode">设备编号</Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item name='keyword'>
                                    <Input placeholder="请输入内容" style={{ width: '260px' }} />
                                </Form.Item>
                            </Input.Group>
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                查询
                            </Button>
                            <Button htmlType="button" onClick={onReset} style={{ marginLeft: '15px' }}>
                                重置
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
            <div className='contextNr'>
                <Table rowKey={record => record.DevId} columns={columns} dataSource={DeviceStore.dataList} className='table-box' pagination={{
                    position: ['bottomRight'],
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSizeOptions: ['10', '20', '30'],
                    pageSize: DeviceStore.limit,
                    current: DeviceStore.page,
                    total: DeviceStore.total,
                    onChange: (page, pageSize) => onPageChange(page, pageSize),
                }} />
                <Modal
                    title={DeviceStore.title}
                    width="700px"
                    key={new Date()}
                    open={DeviceStore.isAshow}
                    footer={null}
                    onCancel={handleAddRole}
                    destroyOnClose={true}
                    centered
                >
                    {
                        DeviceStore.title === '添加设备' && (<Add />)
                    }
                    {
                        DeviceStore.title === '查看数据' && (<Seedata />)
                    }

                </Modal>
            </div>
        </>
    )
}

export default observer(App)